// src/features/dashboard/services/Employee/employeeCompliance.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  EmployeeComplianceRequest,
  ComplianceKpiResponse,
  LoginTrendResponse,
  HoursRequirementResponse,
  PolicyComplianceResponse,
  MonthlyScorecardResponse,
} from '../../types/Employee/employeeCompliance.types';

// const getRequest = (): EmployeeComplianceRequest => ({
//   employeeCode: localStorage.getItem('employeeCode') ?? '',
//   date: new Date().toISOString().split('T')[0],
// });


export const getComplianceKPI = async (
  request: EmployeeComplianceRequest
): Promise<ComplianceKpiResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_COMPLIANCE_KPI,
    request
  );

  console.log("Compilance KPI", data);

  return data;
};

export const getComplianceLoginTrend = async (
  request: EmployeeComplianceRequest
): Promise<LoginTrendResponse[]> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_COMPLIANCE_LOGIN_TREND,
    request
  );

  console.log("Compilance Login", data);
  return data;
};

export const getComplianceHoursRequirement = async (
  request: EmployeeComplianceRequest
): Promise<HoursRequirementResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_COMPLIANCE_HOURS_REQUIREMENT,
    request
  );

  console.log("Compilance Hours", data);
  return data;
};

export const getCompliancePolicy = async (
  request: EmployeeComplianceRequest
): Promise<PolicyComplianceResponse[]> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_COMPLIANCE_POLICY,
    request
  );

  return data;
};

export const getComplianceMonthlyScorecard = async (
  request: EmployeeComplianceRequest
): Promise<MonthlyScorecardResponse[]> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_COMPLIANCE_MONTHLY_SCORECARD,
    request
  );

  return data;
};